import React from 'react'
import queryString from 'qs'
import flowRight from 'lodash/flowRight'
import styled from 'styled-components'
import day from 'dayjs'

import useQuery from 'shared/hooks/useQuery'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import Box from 'shared/components/Box'
import { useSelector } from 'react-redux'
import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'
import Avatar from 'pages/Parent/components/Avatar'
import { screeningSelector, organizationSettingSelector } from 'shared/hocs/withAuth'
import { roleSelector } from 'shared/hocs/withAuth'
type Props = {
  description?: string
  message?: string
  isSecondary: boolean
  screeningDate?: Date
}

function ConfirmationDialog(props: Props) {
  const { description, message, isSecondary = true, screeningDate } = props
  const { organization_information } = useSelector(organizationSettingSelector)
  const { screening } = useSelector(screeningSelector)
  const { isParticipant } = useSelector(roleSelector)

  const subMessage = isParticipant
    ? `Are you attending any in-person Program or Event at ${organization_information.name} today`
    : `Is someone attending any in-person Program or Event at ${organization_information.name} today `
  const DEFAULT_MESSAGE = `${subMessage} (${day((screeningDate || screening?.date)).format('dddd, MMM DD YYYY')})?`

  return (
    <ConfirmationDialogBodyContainer className="confirm-dialog-container" $isSecondary={isSecondary}>
      {description && (
        <Box className="description">{description}</Box>
      )}
      <Box className="message">{message || DEFAULT_MESSAGE}</Box>
    </ConfirmationDialogBodyContainer>
  )
}

const WrappedConfirmationDialog = flowRight(withDialog())(ConfirmationDialog)
const ConfirmationDialogBodyContainer = styled(Box)<{ $isSecondary: boolean }>`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px 40px 0;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .message {
    color: ${({ theme }) => theme.colors.secondary};
    text-align: center;
    margin-top: 32px;

    font-weight: ${({ $isSecondary }) => $isSecondary ? 'bold' : '500'};
    font-size: ${({ $isSecondary }) => $isSecondary ? '18px' : '16px'};
    line-height: 24px;
  }
`

WrappedConfirmationDialog.defaultProps = {
  // continueIsDisabled(data: ConfirmationDialogForm) {
  //   return !data.confirm
  // },
}

export default WrappedConfirmationDialog
